var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thank-you"},[_c('vue-element-loading',{attrs:{"active":_vm.loading,"is-full-screen":""}}),_c('c-header-logo'),_c('v-background'),_c('v-banner'),_c('v-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }